var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconlyBoldTickSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.038 0H3.969C1.596 0 0 1.666 0 4.144v5.72C0 12.334 1.596 14 3.969 14h6.069C12.411 14 14 12.334 14 9.864v-5.72C14 1.666 12.411 0 10.038 0z",
    fill: "url(#ar78d59s3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.77 5.381 6.486 9.77a.767.767 0 0 1-.56.231.761.761 0 0 1-.55-.23L3.23 7.58a.828.828 0 0 1 0-1.146.781.781 0 0 1 1.118 0l1.579 1.617 3.725-3.815a.781.781 0 0 1 1.118 0 .828.828 0 0 1 0 1.145z",
    fill: "url(#br78d59s3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar78d59s3",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br78d59s3",
    x1: 3,
    y1: 4,
    x2: 3,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyBoldTickSquare);
export default __webpack_public_path__ + "static/media/iconly-bold-tick-square.5e2f2078.svg";
export { ForwardRef as ReactComponent };